/**
 * Redux store configuration.
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import documentsReducer from './documentsSlice';
import conversationsReducer from './conversationsSlice';
import foldersReducer from './foldersSlice';
import uploadQueueReducer from './uploadQueueSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    documents: documentsReducer,
    conversations: conversationsReducer,
    folders: foldersReducer,
    uploadQueue: uploadQueueReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['uploadQueue/addToQueue'],
        ignoredPaths: ['uploadQueue.queue'],
      },
    }),
});

export default store;
